import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, OnDestroy {
  private activeTab: string;
  private onTop = false;
  private scrollY = 0;

  constructor(
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router
  ) {
      this.setActiveTab('home');
  };

  ngOnInit() {
    const nav = this;

    window.addEventListener('scroll', (event) => {
      nav.scrollY = window.scrollY;
      if (window.scrollY >= 177) {
        nav.onTop = true;
      } else {
        nav.onTop = false;
      }
    });
  }

  ngOnDestroy() {
    window.removeEventListener('scroll');
  };

  setActiveTab(tab) {
    this.activeTab = tab;
  }

  isSelected(tab) {
    return this.activeTab === tab;
  }
}



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.component.ts